const matchingPatterns = [
  { type: 'Booking', pattern: /(booking.com|kayak.com|trivago.com){1}/i },
  { type: 'Facebook', pattern: /(facebook.){1}(.){0,3}\//i },
  { type: 'Twitter', pattern: /(twitter.com){1}/i },
  { type: 'YouTube', pattern: /(youtube.){1}(.){0,3}\//i },
  { type: 'Tickets', pattern: /(eventbrite.com|viagogo.co.uk|etickets.to){1}/i },
  { type: 'Vimeo', pattern: /(vimeo.com){1}/i },
  { type: 'Soundcloud', pattern: /(soundcloud.com){1}/i },
  { type: 'Bandsintown', pattern: /(bandsintown.com){1}/i },
  { type: 'Snapchat', pattern: /(snapchat.com){1}/i },
  { type: 'WhatsApp', pattern: /(whatsapp.com){1}/i },
  { type: 'Instagram', pattern: /(instagram.com){1}/i },
];

export default function predictUrlType(urlTypes, url) {
  let selectedPattern = matchingPatterns.find(mp => {
    return mp.pattern.test(url)
  });

  if (!selectedPattern) {
    return null
  } else {
    return urlTypes.find(urlType => urlType.name === selectedPattern.type);
  }
}



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/lib/predictUrlType.js